import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Airborne sound insulation - Normalized impact sound pressure level L’n",
  description: "Normalized impact sound pressure levels L’n are shown for all four source  positions.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/05/22/principle/principle-12.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
